import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class EpisodeOfCareStore {
  selectedEpisode: string = '';
  episodeDropDownList: string[] = [];
  //   diseasesMembersMap: Map<string, string[]> = new Map<string, string[]>();

  constructor() {
    makeObservable(this, {
      selectedEpisode: observable,
      episodeDropDownList: observable,
      //   diseasesMembersMap: observable,
      setSelectedEpisode: action,
      removeSelectedEpisode: action,
      setEpisodeDropDownList: action,
      removeEpisodeDropDownList: action,
      //   setDiseasesMembersMap: action,
      //   removeDiseasesMembersMap: action,
      removeEpisodeOfCareStoreData: action,
    });

    makePersistable(this, {
      name: 'EpisodeOfCareStore',
      properties: ['selectedEpisode', 'episodeDropDownList'],
      //   properties: ['episodeDropDownList', 'diseasesMembersMap'],
      storage: window.localStorage,
    });
  }

  setSelectedEpisode(selectedEpisode: string) {
    this.selectedEpisode = selectedEpisode;
  }

  removeSelectedEpisode() {
    this.selectedEpisode = '';
  }

  setEpisodeDropDownList(episodeDropDownList: string[]) {
    this.episodeDropDownList = episodeDropDownList;
  }

  removeEpisodeDropDownList() {
    this.episodeDropDownList = [];
  }

  //   setDiseasesMembersMap(diseasesMembersMap: Map<string, string[]>) {
  //     this.diseasesMembersMap = diseasesMembersMap;
  //   }

  //   removeDiseasesMembersMap() {
  //     this.diseasesMembersMap = new Map<string, string[]>();
  //   }

  removeEpisodeOfCareStoreData() {
    this.episodeDropDownList = [];
    // this.diseasesMembersMap = new Map<string, string[]>();
  }
}

export default EpisodeOfCareStore;
